import React from 'react';
import { Clock } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface TimeAllocation {
  year: string;
  [key: string]: string | number;
}

interface CustomerTimeAllocationChartProps {
  data: TimeAllocation[];
  customers: string[];
  colors: { [key: string]: string };
}

export function CustomerTimeAllocationChart({ data, customers, colors }: CustomerTimeAllocationChartProps) {
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      // Filter out entries with zero values
      const activeCustomers = payload.filter((entry: any) => entry.value > 0);
      
      return (
        <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-100">
          <p className="font-medium text-gray-900 mb-2">Year {label}</p>
          {activeCustomers.map((entry: any) => (
            <div key={entry.name} className="flex items-center justify-between mb-1 last:mb-0">
              <span className="text-sm" style={{ color: entry.color }}>
                {entry.name}
              </span>
              <span className="text-sm ml-4 font-medium">
                {Math.round(entry.value * 100)}%
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
      <div className="flex items-center mb-4">
        <Clock className="w-5 h-5 text-indigo-600 mr-2" />
        <h2 className="text-xl font-semibold text-gray-800">Time Allocation by Customer</h2>
      </div>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            stackOffset="expand"
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="year"
              tick={{ fill: '#6B7280', fontSize: 12 }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <YAxis
              tickFormatter={(value) => `${Math.round(value * 100)}%`}
              tick={{ fill: '#6B7280', fontSize: 12 }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <Tooltip content={<CustomTooltip />} />
            {customers.map((customer) => (
              <Bar
                key={customer}
                dataKey={customer}
                stackId="a"
                fill={colors[customer] || '#3B82F6'}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}